import alert from '@/plugins/alert'
import axios from '@/plugins/axios'
import { Dish } from '@/plugins/api'
import { rangeRight } from 'lodash-es'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'

export default {
  namespaced: true,
  state: {
    loading: false,
    dishData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    dishSearchParams: {},
    totalItems: 0,
    dishes: []
  },
  actions: {
    async searchDishList({ commit, state, dispatch }, query) {
      const dishSearchParams = {
        _limit: state.itemsPerPage,
        ...query
      }

      commit('changeState', { dishSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.dishSearchParams) {
        const dishSearchParams = {
          ...state.dishSearchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'name:ASC'
        }
        const [totalItems, dishes] = await Promise.all([Dish.count(dishSearchParams), Dish.search(dishSearchParams)])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            dishes,
            totalItems,
            itemsPerPage,
            dishSearchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }

      commit('changeState', { loading: false })
    },
    uploadImage(_, formData) {
      return axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then()
        .catch(() => alert.error('Tải ảnh thất bại'))
    },
    destroyImage(_, id) {
      return axios
        .delete(DESTROY_API + id)
        .then()
        .catch(e => alert.error(e))
    },
    async createDish({ commit, state }, dishData) {
      try {
        const c = await Dish.create(dishData)
        commit('changeState', {
          dishes: [c, ...state.dishes]
        })
        return c
      } catch (e) {
        alert.error(e)
      }
    },
    async updateDish({ commit }, { id, ...dishData }) {
      const d = await Dish.update(id, dishData)
      commit('updateDish', d)
      return d
    },
    async removeDish({ commit }, id) {
      await Dish.remove(id)
      commit('removeDish', id)
    },
    setDish({ commit }, dishData) {
      commit('setDish', dishData)
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateDish(state, dishData) {
      const dishes = state.dishes.map(c => {
        if (dishData.id === c.id) return dishData
        else return c
      })
      state.dishes = dishes
    },
    removeDish(state, id) {
      const dishes = state.dishes.filter(d => d.id !== id)
      state.dishes = dishes
    }
  },
  getters: {}
}
